import { merge } from "lodash"
import defaultConfig from "./configuration/default"

export default {
  materialType: "statute-metadata",
  languages: [
    "fi",
    "sv",
  ],
  title: "label.statuteReferenceCard",
  description: "description.statuteReferenceCard",
  configuration: merge({}, defaultConfig, {
    actions: { languages: true },
    listing: {
      caption: true,
      title: true,
      type: true,
    },
  }),
}
